module.exports = __webpack_public_path__ + "static/media/CheckboxChecked.1edbf7ff.svg";